var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal-target',{attrs:{"name":"video-player"}}),_c('cookies-info'),_c('top-search-bar'),_c('heading-section'),_c('segment-news'),_c('auctions-counter'),_c('pandemy-info-boxes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }